import {
	Component,
	OnInit,
	Input,
	Output,
	EventEmitter,
	ChangeDetectionStrategy,
} from "@angular/core"
import { Router } from "@angular/router"
import { Modalable } from "@app/Modalable"
import { COMMON_IMPORTS } from "../common-imports"
import {
	ConfigDefinitions,
	patientColors,
	taxesList,
	yes_no_opts,
} from "@app/definitions/types"
import * as moment from "moment"
import {
	BtnExtComponent,
	Check,
	PatientModalComponent,
	SpinOrContent,
} from "@app/utils/utils.component"
import { LangValPipe } from "@app/utils/lang-val.pipe"
import { AddTask } from "@app/add-task/add-task"
import { LocalTimePipe } from "@app/utils/local-time.pipe"
import { DateFormatPipe } from "@app/utils/date-format.pipe"
import { TimeFormatPipe } from "@app/utils/time-format.pipe"
import { GenInputComponent } from "@app/gen-inputs/gen-input/gen-input.component"
import { AutocompleteMultiComponent } from "@app/gen-inputs/autocomplete-multi/autocomplete-multi.component"
import { GenButtonGroupComponent } from "@app/gen-inputs/gen-button-group/gen-button-group.component"
import { ModalWrapComponent } from "@app/modal-wrap/modal-wrap.component"
import { MrMotionsComponent } from "@app/mr-motions/mr-motions.component"
import { SignDocumentsComponent } from "@app/sign-documents/sign-documents.component"
import { MeetingRequestsComponent } from "@app/meeting-requests/meeting-requests.component"
import { TaskschedulesComponent } from "@app/taskschedules/taskschedules.component"
import { InsertPatientFormComponent } from "@app/insert-patient-form/insert-patient-form.component"
import { SlicePipe } from "@angular/common"
import { ConfirmComponent } from "@app/confirm/confirm.component"

@Component({
	selector: "app-task",
	imports: [
		COMMON_IMPORTS,
		SpinOrContent,
		LangValPipe,
		AddTask,
		Check,
		LocalTimePipe,
		DateFormatPipe,
		TimeFormatPipe,
		GenInputComponent,
		AutocompleteMultiComponent,
		BtnExtComponent,
		PatientModalComponent,
		GenButtonGroupComponent,
		ModalWrapComponent,
		MrMotionsComponent,
		SignDocumentsComponent,
		MeetingRequestsComponent,
		TaskschedulesComponent,
		InsertPatientFormComponent,
		SlicePipe,
		ConfirmComponent,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: "./task.component.html",
})
export class TaskComponent extends Modalable {
	modalProps: any = null
	isApprovingPatientDetails: boolean = false

	ConfigDefinitions = ConfigDefinitions
	@Input() taskId: number = 0
	@Input() patient_id: number = 0
	@Input() patientRow: any
	openTasks: any[] = [] //the list of open tasks by users (and most recent message)
	userId: number = 0 //current focused userId (for the messages window)
	excludeIds: number[] = []
	isAllOpen: boolean = false
	isFirstInit: boolean = false
	isLoading: boolean = false
	tabindexStart: number = 1000000
	changedTasksInterval: any = null
	isShowingClosedToo: boolean = false
	ignoreDate: boolean = false
	intervalSecs: number = 60
	intervalGetTasks: any = null
	showAddTask: boolean = true

	pageSize: number = 20
	pageNumbers: number[] = []

	curPage: number = 0

	inquiry_statuses: any[] = []
	inquiry_statuses_names: any = {}
	today: string = ""
	isPartner: boolean = false
	isShowClosed: yes_no_opts = "no"

	ngOnInit() {
		//when called to open get tasks and load the first one's userId into the messages window
		this.isPartner = !!this.store.getSiteDataTable("partners")?.length
		this.userId = this.store.cc()?.user_id
		this.excludeIds = this.store.getNonClinicalSubUserIds()
		this.today = moment.utc().format(ConfigDefinitions.momentDateFormat)
		if (this.patientRow?.id) {
			this.patient_id = this.patientRow.id
		}

		this.getTasks()
		//-1 is meeting was set, -2 is assigned to assoc, -3 is unassigned to assoc
		this.inquiry_statuses = this.store.getInquiryStatuses() //check the current react implementation!
		this.inquiry_statuses_names = this.store.getInquiryStatusNamesAsObj()
		this.isShowingClosedToo = false
		this.store.modalCloseRequestSubject.subscribe((name: string) => {
			if (name === "task") {
				this.onClose.emit()
			}
		})
	}

	postGetTasksInterval(res: any) {
		if (!res?.tasks) {
			return
		}
		//closed/opened - remove
		//recipient without me - remove
		for (let task of this.openTasks) {
			const newTask = res.tasks.find((t) => t.id == task.id)
			if (!newTask) {
				this.openTasks = this.openTasks.filter((t) => t.id != task.id)
				continue
			}

			//changed status,
			task.inquiry_status_id = newTask.inquiry_status_id
			task.recipient_statuses = newTask.recipient_statuses
			task.patientAssoc = newTask.patientAssoc

			this.taskPrepUpdate(newTask, task)

			//new motions,
			//new comments,
			//isuptodate recipients,

			//new recipients,
			//deleted recipinets,
			//new assoc for patient,
			//deleted assoc for patient,
		}
		this.pushToSubject()
	}

	startInterval() {
		this.endInterval()
		this.changedTasksInterval = setInterval(() => {
			if (this.isLoading) {
				return
			}
			const ids = this.openTasks.map((t) => t.id)
			this.intervalGetTasks = this.apiService.postSubscribe(
				"get_tasks",
				{ ...this.getTasksObj(), ids },
				this.postGetTasksInterval.bind(this)
			)
		}, this.intervalSecs * 1000)
	}
	endInterval() {
		if (this.changedTasksInterval) {
			clearInterval(this.changedTasksInterval)
		}
		this.intervalGetTasks?.unsubscribe()
	}

	ngOnDestroy() {
		this.endInterval()
	}

	processSyncChanges(res: any) {
		if (res?.tasksChanged) {
			this.getTasks()
		}
		if (res?.closedTasks?.length) {
			res.closedTasks.forEach((ctId) => {
				const task = this.openTasks.find((t) => t.id == ctId)
				if (task) {
					task.closed = "yes"
				}
			})
			if (!this.isShowingClosedToo) {
				this.openTasks = this.openTasks.filter(
					(t) => !res.closedTasks.includes(t.id)
				)
			}
		}
		if (res?.newTasks?.length) {
			res.newTasks = res.newTasks.filter(
				(t) => !this.openTasks.find((ot) => ot.id == t.id)
			)
			res.newTasks.forEach((task) => {
				this.taskPrepFromServer(task)
			})
			this.openTasks = [...this.openTasks, ...res.newTasks]
			// this.filterOpenForFus();
		}
		if (res?.recipientsUptodate?.length) {
			res.recipientsUptodate.forEach((tr) => {
				const task = this.openTasks.find((t) => t.id == tr.task_id)
				if (task) {
					if (tr.user_id == this.userId) {
						task.is_uptodate = tr.is_uptodate
					}
					const innerTr = task.recipients.find(
						(itr) => itr.user_id == tr.user_id
					)
					if (innerTr) {
						innerTr.is_uptodate = tr.is_uptodate
					}
				}
			})
		}
		if (res?.newTaskComments?.length) {
			res.newTaskComments.forEach((tc) => {
				const task = this.openTasks.find((t) => t.id == tc.task_id)
				if (task) {
					const alreadyExistsComment = task.comments.find((c) => c.id == tc.id)
					if (alreadyExistsComment) {
						return
					}

					this.store.removeDecItem(tc)
					this.prepTaskCommentOrMotion(tc)
					task.comments = [...task.comments, tc]
					this.combineTaskCommentOrMotion(task)
				}
			})
		}
		if (res?.newTaskMotions?.length) {
			res.newTaskMotions.forEach((tm) => {
				const task = this.openTasks.find((t) => t.id == tm.task_id)
				if (task) {
					const alreadyExistsMotion = task.motions.find((c) => c.id == tm.id)
					if (alreadyExistsMotion) {
						return
					}

					this.store.removeDecItem(tm)
					this.prepTaskCommentOrMotion(tm)
					task.motions = [...task.motions, tm]
					task.inquiry_status_id = tm.inquiry_status_id
					this.combineTaskCommentOrMotion(task)
				}
			})
		}
	}

	// filterOpenForFus(){
	//   if(this.task && this.openTasks?.length){
	//     // this.openTasks=this.openTasks.filter(t=>t.followupserie_id==this.task.followupserie_id);
	//   }
	// }

	getTasksObj() {
		return {
			ignoreDate: this.ignoreDate,
			getClosedToo: this.isShowingClosedToo,
			patient_id: this.patient_id,
			curPage: this.curPage,
		}
		//followupserie_id:this.task?.followupserie_id,
	}

	async getTasks(ignoreDate: boolean = false, getClosedToo: boolean = false) {
		this.isShowingClosedToo = getClosedToo
		this.ignoreDate = ignoreDate
		console.log("ignoreDate " + this.ignoreDate)
		console.log("isShowingClosedToo " + this.isShowingClosedToo)
		this.isLoading = true
		this.endInterval()

		const objToSend: any = this.getTasksObj()
		if (this.taskId) {
			objToSend.ids = [this.taskId]
			this.taskId = 0
		}
		const res: any = await this.apiService.post("get_tasks", objToSend)
		this.isLoading = false
		this.pageNumbers = []
		for (let i = 0; i < res.count / this.pageSize; i++) {
			this.pageNumbers.push(i)
		}
		this.openTasks = res.tasks
		// this.filterOpenForFus();
		this.openTasks.forEach((task) => {
			this.taskPrepFromServer(task)
		})
		this.startInterval()
		// 	r.firstLetter = r.user_name.substr(0, 1);	//get the first letter of the user's name (for badge display)
		// if (this.openTasks.length) {	//if has any task - load the first one into the messages window (using userId)
		// 	this.userId = this.openTasks[0].user_id;
		// }
	}

	taskPrepUpdate(newTask: any, task: any) {
		this.store.removeDecItem(newTask)
		if (newTask?.comments?.length) {
			this.store.removeDecArr(newTask.comments)
			newTask.comments.forEach((t) => this.prepTaskCommentOrMotion(t))
		}
		if (newTask?.motions?.length) {
			newTask.motions.forEach((t) => this.prepTaskCommentOrMotion(t))
		}
		task.comments = newTask.comments
		task.motions = newTask.motions

		this.resetTaskRecipients(task)
		this.combineTaskCommentOrMotion(task)
		this.updateTaskRecipientIds(task)
	}

	taskPrepFromServer(task: any) {
		task.isCreator = task.user_id == this.userId
		task.sender = ""
		const sender = this.store.searchSiteDataItem(task.user_id, ["sub_users"])
		task.sender = sender?.name || ""
		task.person = ""
		task.is_uptodate = "no"
		if (task.patient_id || task.contact_id) {
			const personType = task.patient_id ? "patients" : "contacts"
			const idToFind = task.patient_id || task.contact_id
			const person = this.store.searchSiteDataItem(idToFind, [personType])
			task.person = person?.name || ""
		}
		this.taskPrepUpdate(task, task)

		// task.comments = null;
		task.newComment = ""
		task.new_inquiry_status_id = 0

		// this.openCloseChat(task)
		task.chat_open = this.isAllOpen
	}
	async assocAddItem(obj: any, task: any) {
		const item = {
			user_id: obj.id,
			item_id: task.patient_id,
			item_type: "patient",
			active: "yes",
			task_id: task.id,
		}
		const res = await this.apiService.post("add_task_assoc", item)
		this.postAssocChange(res, task)

		task.patientAssoc = [...task.patientAssoc, obj?.id]
		task.recipient_statuses = [
			...task.recipient_statuses,
			{ user_id: obj?.id, is_uptodate: "no" },
		]
		this.resetTaskRecipients(task)
		this.updateTaskRecipientIds(task)
		this.pushToSubject()
	}

	async recipientAddItem(obj: any, task: any) {
		const item = { task_id: task.id, user_id: obj.id }
		const res: any = await this.apiService.post("add_task_recipient", item)
		this.postAssocChange(res, task)
	}
	async assocDeleteItem(id: any, task: any) {
		const item = {
			user_id: id,
			item_id: task.patient_id,
			item_type: "patient",
			task_id: task.id,
		}
		const res = await this.apiService.post("delete_task_assoc", item)
		this.postAssocChange(res, task)

		task.patientAssoc = task.patientAssoc.filter((it) => it != id)
		task.recipient_statuses = task.recipient_statuses.filter(
			(row) => row.user_id != id
		)
		this.resetTaskRecipients(task)
		this.updateTaskRecipientIds(task)
		this.pushToSubject()
	}
	async recipientDeleteItem(id: any, task: any) {
		const item = { user_id: id, task_id: task.id }
		const res: any = await this.apiService.post("delete_task_recipient", item)
		this.postAssocChange(res, task)
	}
	postAssocChange(res: any, task: any) {
		if (res?.motion) {
			this.prepTaskCommentOrMotion(res.motion)
			task.motions.push(res.motion)
			this.combineTaskCommentOrMotion(task)
		}
		if (res?.recipient_statuses) {
			task.recipient_statuses = res.recipient_statuses
			this.resetTaskRecipients(task)
		}
		this.updateTaskRecipientIds(task)
	}
	resetTaskRecipients(task: any) {
		task.recipients = []
		if (task?.recipient_statuses && task?.recipient_statuses?.length) {
			task.recipient_statuses.forEach((rs) => {
				if (rs.user_id == this.userId) {
					task.is_uptodate = rs.is_uptodate
				}
				if (rs.user_id == task.user_id) {
					return
				}
				task.recipients.push({
					...rs,
					name:
						this.store.searchSiteDataItem(rs.user_id, ["sub_users"])?.name ||
						"",
				})
			})
		}
	}

	updateTaskPatentAssoc(task: any) {
		// task.assoc=task.recipients.map(it=>it.user_id);
	}
	updateTaskRecipientIds(task: any) {
		task.recipientIds = task.recipients.map((it) => it.user_id)
	}

	setIsUptodate(task: any) {
		this.apiService.post("set_is_uptodate", {
			task_id: task.id,
			is_uptodate: "yes",
		})
		task.is_uptodate = "yes"
		if (this.store.unreadTasks) {
			this.store.unreadTasks--
		}
	}

	openCloseAllChats() {
		this.isAllOpen = !this.isAllOpen

		this.openTasks.forEach((task) => {
			task.chat_open = this.isAllOpen
		})
	}

	openCloseChat(task: any) {
		task.chat_open = !task.chat_open
	}
	async openCloseTask(task: any) {
		const isNewClosed = task.closed !== "yes"
		if (isNewClosed && task.meeting_request?.id) {
			this.modalProps = { name: "confirm-close", task }
			return
		}
		this.handleCloseConfirm(task)
	}
	async handleCloseConfirm(task: any) {
		this.modalProps = null
		const isNewClosed = task.closed !== "yes"
		task.isOpenClosing = true
		await this.apiService.post("open_close_task", { task_id: task.id })
		task.isOpenClosing = false
		if (isNewClosed && task.meeting_request?.id) {
			this.deactivateMeetingRequest(task)
		}
		task.closed = isNewClosed ? "yes" : "no"
		if (!this.isShowingClosedToo && isNewClosed) {
			// this.openTasks = this.openTasks.filter((t) => t.id != task.id)
		}
		this.store.get_task_notifications_total()
	}

	async update_inquiry_status_id(task: any) {
		task.new_inquiry_status_id = Number(task.new_inquiry_status_id)
		if (!task.new_inquiry_status_id) {
			return
		}
		const res: any = await this.apiService.post("update_inquiry_status_id", {
			task_id: task.id,
			inquiry_status_id: task.new_inquiry_status_id,
		})
		if (res) {
			this.prepTaskCommentOrMotion(res)
			task.motions.push(res)
			this.combineTaskCommentOrMotion(task)
			task.inquiry_status_id = task.new_inquiry_status_id
			this.pushToSubject()
		}
	}
	async addCommentAndStatus(task: any) {
		task.new_inquiry_status_id = Number(task.new_inquiry_status_id)
		task.newComment = task.newComment.trim()
		// if (!task.newComment || task.new_inquiry_status_id) { return; }
		task.commentSending = true
		const res: any = await this.apiService.post(
			"create_task_comment_and_status",
			{
				task_id: task.id,
				inquiry_status_id: task.new_inquiry_status_id,
				content: task.newComment,
			}
		)
		task.commentSending = false
		if (!res) {
			return
		}
		if (res?.comment) {
			const comment = res.comment
			this.store.removeDecItem(comment)
			this.prepTaskCommentOrMotion(comment)
			task.comments = [...task.comments, comment]
			this.combineTaskCommentOrMotion(task)
			task.newComment = ""
			task.new_inquiry_status_id = 0
			task.recipients.forEach((r) => {
				r.is_uptodate = r.user_id == this.userId ? "yes" : "no"
			})
		}
		if (res?.motion) {
			const motion = res.motion
			this.prepTaskCommentOrMotion(motion)
			task.motions.push(motion)
			this.combineTaskCommentOrMotion(task)
			task.inquiry_status_id = task.new_inquiry_status_id
		}
		this.pushToSubject()
	}
	combineTaskCommentOrMotion(task: any) {
		task.commentsOrMotions = [...task.comments, ...task.motions]
		task.commentsOrMotions.sort((a, b) => {
			return new Date(b.created_at) > new Date(a.created_at) ? -1 : 1
		})
	}

	prepTaskCommentOrMotion(commentOrMotion: any) {
		const userId = this.store.cc()?.user_id
		const alpha = "A9"
		// comment.content = comment.content_dec;
		commentOrMotion.userName =
			this.store.searchSiteDataItem(commentOrMotion.user_id, ["sub_users"])
				?.name || ""
		commentOrMotion.color =
			patientColors[commentOrMotion.user_id % patientColors.length] + alpha
		commentOrMotion.isMine = commentOrMotion.user_id == userId
		commentOrMotion.datetime = moment
			.utc(commentOrMotion.created_at)
			.format("HH:mm " + ConfigDefinitions.momentDateDisplay)
		if (commentOrMotion.inquiry_status_id) {
			commentOrMotion.status =
				this.inquiry_statuses_names[commentOrMotion.inquiry_status_id] ||
				this.lang.getVal("none")
			commentOrMotion.actor =
				this.store.searchSiteDataItem(commentOrMotion.actor_id, ["sub_users"])
					?.name || ""
		}
	}

	changeToIrrelevant(task: any) {
		task.new_inquiry_status_id = -6
		this.update_inquiry_status_id(task)
	}

	pushToSubject() {
		const fields = [
			this.store.crGenTableUpdateField(
				"inquiry_status_id",
				"inquiry_status_id"
			),
			this.store.crGenTableUpdateField("assoc", "patientAssoc"),
		]
		this.store.updateGenTable("inquirers", this.openTasks, fields, "patient_id")
	}
	async openContext(task: any) {
		this.router.navigateByUrl("/calendar")
		await this.store.timeout(1000)
		this.store.calendarOpenMeetingTaskContextSubject.next({
			context: task.context,
			followupserie_id: task.followupserie_id,
		})
	}

	async schedMeeting(task: any) {
		//close tasks modal, go to calendar in the week of MR date, open add-meeting modal with the MR date/time
		this.router.navigateByUrl("/calendar")
		this.onClose.emit()
		await this.store.timeout(200)
		this.store.calendarOpenMeetingSubject.next(task.meeting_request)
	}
	openNewPatient(meeting_request: any) {
		this.modalProps = {
			name: "insert-patient-form",
			meeting_request: this.store.removeDecItem(meeting_request),
		}
	}
	async handleInsertPatientClose(ret: any) {
		if (!ret) {
			return
		}
		await this.store.changeMrStatus(
			this.modalProps.meeting_request.id,
			"accepted"
		)
		if (ret?.doClose) {
			this.onClose.emit()
		}
	}
	async deactivateMeetingRequest(task: any) {
		if (task.meeting_request?.id) {
			task.deactivateSpin = true
			await this.store.deactivate_meeting_request(task.meeting_request.id)
			task.deactivateSpin = false
			delete task.meeting_request
			this.store.calendarChangesSubj.next(true)
		}
	}

	handleFinishedNewTask() {
		this.getTasks()
		this.showAddTask = false
		setTimeout(() => {
			this.showAddTask = true
		})
	}

	handleSchedulerClose(ret: any) {
		if (!ret) {
			return
		}
		this.getTasks()
		//this is just for reloading purposes!
		this.showAddTask = false
		setTimeout(() => (this.showAddTask = true))
	}
	handleShowClosedChange() {
		this.curPage = 0
		if (this.isShowClosed === "yes") {
			this.getTasks(true, true)
		} else {
			this.getTasks(false, false)
		}
	}
}
